import React from "react";
interface DescriptionWithLinksProps {
  text: string;
}

/**
 * Component to render text with clickable links
 * @param text The text to render with links
 * @returns JSX element with clickable links
 */
export const DescriptionWithLinks = ({
  text
}: DescriptionWithLinksProps) => {
  if (!text) return null;

  // URL regex pattern to detect URLs
  const urlRegex = /(https?:\/\/[^\s]+)/g;

  // Split text by URLs and create elements
  const parts = text.split(urlRegex);
  return <>
      {parts.map((part, index) => {
      // Check if this part is a URL
      if (urlRegex.test(part)) {
        return <a key={index} href={part} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300" onClick={e => {
          // Prevent the modal from opening when clicking the link
          e.stopPropagation();
        }}>
              {part}
            </a>;
      }
      // Regular text
      return <span key={index}>{part}</span>;
    })}
    </>;
};